module.exports = "/assets/data/a76add008df4a383c8a40ded3ca9c7ed-E6.data.json";